import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import moment from "moment";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CartasProveedores from "./cartas/cartasProveedor";
import CatalogoAlmacen from "../../catalogos/catalogoAlmacen";

const TablaVendedores = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let anio = JSON.parse(sessionStorage.getItem("anioactu"));
  let idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
  const accbtnvendedor = JSON.parse(sessionStorage.getItem("accbtnvendedorc"));
  let muni = "";
  let ciu = "";

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CODIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "NOMBRE",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "RIF",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const fechaTope = moment(JSON.parse(sessionStorage.getItem("fechasistema")))
    .format("YYYY-MM-DD")
    .replace(anio.toString(), (anio - 18).toString());

  const txtBuscador = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkNatural = useRef();
  const chkJuridico = useRef();
  const txtId = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtRazon = useRef();
  const txtDirClient = useRef();
  const txtEmailClient = useRef();
  const txtTlf1Client = useRef();
  const txtTlf2Client = useRef();
  const txtEstado = useRef();
  const txtMunicipio = useRef();
  const txtCiudad = useRef();

  const txtCodAlmacen = useRef();
  const txtDescripcion = useRef();

  const txtpreciomaxventa = useRef();
  const txtprecioofventa = useRef();
  const txtpreciomayventa = useRef();
  const txtpreciominventa = useRef();
  const txtdebajominventa = useRef();
  const txtpreciomaxservi = useRef();
  const txtprecioofservi = useRef();
  const txtpreciomayservi = useRef();
  const txtpreciominservi = useRef();
  const txtdebajominservi = useRef();
  const txtpreciomaxcob = useRef();
  const txtprecioofcob = useRef();
  const txtpreciomaycob = useRef();
  const txtdebajomincob = useRef();
  const txtservimincob = useRef();
  const txtgeneralcob = useRef();

  const cmbNacionalidad = useRef();
  const txtCedRes = useRef();
  const cmbSexo = useRef();
  const txtFechaNac = useRef();
  const txtNomResp = useRef();
  const txtApeResp = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();

  const [body, setBody] = useState(null);
  const [registrado, setRegistrado] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [catalogoPersona, setCatalogoPersona] = useState(false);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [catalogoUsuario, setCatalogoUsuario] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [tituloHeader, setTituloHeader] = useState("Gestionar Vendedores.");

  const [totalr, setTotalr] = useState(0);
  const [totalact, setTotalact] = useState(0);
  const [totalinc, setTotalinc] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [titleCed, setTitleCed] = useState("Cédula:");
  const [cmbCedula, setCmbCedula] = useState([{ value: "V" }, { value: "E" }]);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tipoAgente, setTipoAgente] = useState("");
  const [catalogoAlmacen, setCatalogoAlmacen] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
    tab1: true,
    tab2: true,
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const datosRes = () => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let nomid2 = "nacionalidad";
    let id = txtCedRes.current.value;
    let id2 = cmbNacionalidad.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          cmbSexo.current.value = "";
          txtFechaNac.current.value = "";
          txtNomResp.current.value = "";
          txtApeResp.current.value = "";
          txtDireccion.current.value = "";
          txtEmail.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";

          if (response.data !== "") {
            setHabilitadoNU(true);
            setOperacionPer(0);
            cmbSexo.current.value = response.data.sexo;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            txtNomResp.current.value = response.data.nombres;
            txtApeResp.current.value = response.data.apellidos;
            txtDireccion.current.value = response.data.direccion;
            txtEmail.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            if (!botones.consultar) {
              btnCancela.current.focus();
            } else {
              btnAcepta.current.focus();
            }
          } else {
            txtNomResp.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto:
                "No existe una persona con este N° de cedula porfavor registre sus datos",
              icono: "informacion",
            });
            setOperacionPer(1);
            setHabilitadoNU(false);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "estado";
    let orden = "idestado";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEstados(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const selectMunicipios = (id) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
          if (
            registrado ||
            !botones.consultar ||
            !botones.modificar ||
            !botones.eliminar
          ) {
            txtMunicipio.current.value = muni;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudades(response.data);
          if (
            registrado ||
            !botones.consultar ||
            !botones.modificar ||
            !botones.eliminar
          ) {
            txtCiudad.current.value = ciu;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = (rif) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let nomid2 = "vendedor";
    let id = rif;
    let endpoint = "";

    if (!botones.incluir) {
      endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    } else {
      endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;
    }
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          txtId.current.value = 0;
          txtRazon.current.value = "";
          txtDirClient.current.value = "";
          cmbNacionalidad.current.value = "";
          txtCedRes.current.value = "";
          txtTlf1Client.current.value = "";
          txtTlf2Client.current.value = "";
          txtEmailClient.current.value = "";
          txtEstado.current.value = "";
          txtMunicipio.current.value = "";
          txtCiudad.current.value = "";
          txtpreciomaxventa.current.value = "0,00";
          txtprecioofventa.current.value = "0,00";
          txtpreciomayventa.current.value = "0,00";
          txtpreciominventa.current.value = "0,00";
          txtdebajominventa.current.value = "0,00";
          txtpreciomaxservi.current.value = "0,00";
          txtprecioofservi.current.value = "0,00";
          txtpreciomayservi.current.value = "0,00";
          txtpreciominservi.current.value = "0,00";
          txtdebajominservi.current.value = "0,00";
          txtpreciomaxcob.current.value = "0,00";
          txtprecioofcob.current.value = "0,00";
          txtpreciomaycob.current.value = "0,00";
          txtdebajomincob.current.value = "0,00";
          txtservimincob.current.value = "0,00";
          txtgeneralcob.current.value = "0,00";
          txtDescripcion.current.value = "";

          txtCedRes.current.value = "";
          cmbSexo.current.value = "";
          txtFechaNac.current.value = "";
          txtNomResp.current.value = "";
          txtApeResp.current.value = "";
          txtDireccion.current.value = "";
          txtEmail.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";

          setRecords([]);

          if (response.data !== "") {
            setOperacionPer(0);

            if (!botones.incluir) {
              setRegistrado(true);
            } else {
              setRegistrado(false);
            }

            txtId.current.value = response.data.idagente;
            txtRazon.current.value = response.data.nombre.trim();
            txtDirClient.current.value = response.data.direccion.trim();
            chkNatural.current.checked =
              response.data.tipoper === 0 ? true : false;
            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
            txtRif.current.value = response.data.rif.trim().substring(1, 10);
            txtTlf1Client.current.value = response.data.telefono;
            txtTlf2Client.current.value = response.data.celular;
            txtEmailClient.current.value =
              response.data.email !== null ? response.data.email.trim() : "";
            txtEstado.current.value = response.data.estado.trim();
            txtpreciomaxventa.current.value = formatMoneda(
              response.data.preciomaxventa.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtprecioofventa.current.value = formatMoneda(
              response.data.precioofventa.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtpreciomayventa.current.value = formatMoneda(
              response.data.preciomayventa.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtpreciominventa.current.value = formatMoneda(
              response.data.preciominventa.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtdebajominventa.current.value = formatMoneda(
              response.data.debajominventa.toString().replace(".", ","),
              ",",
              ".",
              2
            );

            txtpreciomaxservi.current.value = formatMoneda(
              response.data.preciomaxservi.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtprecioofservi.current.value = formatMoneda(
              response.data.precioofservi.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtpreciomayservi.current.value = formatMoneda(
              response.data.preciomayservi.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtpreciominservi.current.value = formatMoneda(
              response.data.preciominservi.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtdebajominservi.current.value = formatMoneda(
              response.data.debajominservi.toString().replace(".", ","),
              ",",
              ".",
              2
            );

            txtpreciomaxcob.current.value = formatMoneda(
              response.data.preciomaxcob.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtprecioofcob.current.value = formatMoneda(
              response.data.precioofcob.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtpreciomaycob.current.value = formatMoneda(
              response.data.preciomaycob.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtdebajomincob.current.value = formatMoneda(
              response.data.debajomincob.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtservimincob.current.value = formatMoneda(
              response.data.servimincob.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtgeneralcob.current.value = formatMoneda(
              response.data.generalcob.toString().replace(".", ","),
              ",",
              ".",
              2
            );

            cmbNacionalidad.current.value = response.data.reprelegal
              .trim()
              .substring(0, 1);
            txtCedRes.current.value = response.data.reprelegal
              .trim()
              .substring(1, 12);
            txtCodAlmacen.current.value = response.data.idalmacen;

            muni = response.data.municipio.trim();
            ciu = response.data.ciudad.trim();

            selectMunicipios(response.data.estado.trim());
            selectCiudad(response.data.municipio.trim());
            datosRes();
            cargarClientes(response.data.idagente);
            seleccionarAlmacen(response.data.idalmacen);

            if (!botones.modificar) {
              setBotones({ ...botones, catalogoper: false });
            }
          } else {
            txtRazon.current.focus();
            if (botones.incluir) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "No existe un vendedor con este codigo",
                icono: "informacion",
              });
            }

            txtId.current.value = 0;
            txtRazon.current.value = "";
            txtDirClient.current.value = "";
            cmbNacionalidad.current.value = "";
            txtCedRes.current.value = "";
            txtTlf1Client.current.value = "";
            txtTlf2Client.current.value = "";
            txtEmailClient.current.value = "";
            txtEstado.current.value = "";
            txtMunicipio.current.value = "";
            txtCiudad.current.value = "";
            txtCedRes.current.value = "";
            cmbSexo.current.value = "";
            txtFechaNac.current.value = "";
            txtNomResp.current.value = "";
            txtApeResp.current.value = "";
            txtDireccion.current.value = "";
            txtEmail.current.value = "";
            txtTlf1.current.value = "";
            txtTlf2.current.value = "";

            txtpreciomaxventa.current.value = "0,00";
            txtprecioofventa.current.value = "0,00";
            txtpreciomayventa.current.value = "0,00";
            txtpreciominventa.current.value = "0,00";
            txtdebajominventa.current.value = "0,00";
            txtpreciomaxservi.current.value = "0,00";
            txtprecioofservi.current.value = "0,00";
            txtpreciomayservi.current.value = "0,00";
            txtpreciominservi.current.value = "0,00";
            txtdebajominservi.current.value = "0,00";
            txtpreciomaxcob.current.value = "0,00";
            txtprecioofcob.current.value = "0,00";
            txtpreciomaycob.current.value = "0,00";
            txtdebajomincob.current.value = "0,00";
            txtservimincob.current.value = "0,00";
            txtgeneralcob.current.value = "0,00";

            setRecords([]);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Vendedores.");
    setVisibleBtn("visible");
    setActivate(false);
    setBody(null);
    setRegistrado(false);
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
    setMunicipios([]);
    setCiudades([]);
    setRecords([]);
    setTitleCed("Cédula:");
    setCmbCedula([{ value: "V" }, { value: "E" }]);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
      tab1: true,
      tab2: true,
    });
    chkNatural.current.checked = true;
    cmbRif.current.value = "";
    txtRif.current.value = "";
    txtId.current.value = 0;
    txtRazon.current.value = "";
    txtDirClient.current.value = "";
    txtTlf1Client.current.value = "";
    txtTlf2Client.current.value = "";
    txtEmailClient.current.value = "";
    txtEstado.current.value = "";
    txtMunicipio.current.value = "";
    txtCiudad.current.value = "";
    txtpreciomaxventa.current.value = "0,00";
    txtprecioofventa.current.value = "0,00";
    txtpreciomayventa.current.value = "0,00";
    txtpreciominventa.current.value = "0,00";
    txtdebajominventa.current.value = "0,00";
    txtpreciomaxservi.current.value = "0,00";
    txtprecioofservi.current.value = "0,00";
    txtpreciomayservi.current.value = "0,00";
    txtpreciominservi.current.value = "0,00";
    txtdebajominservi.current.value = "0,00";
    txtpreciomaxcob.current.value = "0,00";
    txtprecioofcob.current.value = "0,00";
    txtpreciomaycob.current.value = "0,00";
    txtdebajomincob.current.value = "0,00";
    txtservimincob.current.value = "0,00";
    txtgeneralcob.current.value = "0,00";

    txtCodAlmacen.current.value = "";
    txtDescripcion.current.value = "";

    cmbRif.current.setAttribute("disabled", "disabled");
    txtRif.current.setAttribute("disabled", "disabled");
    chkNatural.current.setAttribute("disabled", "disabled");
    chkJuridico.current.setAttribute("disabled", "disabled");

    cmbNacionalidad.current.value = "";
    txtCedRes.current.value = "";
    cmbSexo.current.value = "";
    txtFechaNac.current.value = "";
    txtNomResp.current.value = "";
    txtApeResp.current.value = "";
    txtDireccion.current.value = "";
    txtEmail.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtCedRes.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar la cedula el responsable",
          icono: "informacion",
        });
        txtCedRes.current.focus();
        sigue = false;
      } else if (operacionPer === 1) {
        if (cmbNacionalidad.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar la nacionalidad del responsable",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
          sigue = false;
        } else if (cmbSexo.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar el Sexo del responsable",
            icono: "informacion",
          });
          cmbSexo.current.focus();
          sigue = false;
        } else if (txtFechaNac.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar fecha nacimiento del responsable",
            icono: "informacion",
          });
          txtFechaNac.current.focus();
          sigue = false;
        } else if (txtNomResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el nombre del responsable",
            icono: "informacion",
          });
          txtNomResp.current.focus();
          sigue = false;
        } else if (txtApeResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el apellido del responsable",
            icono: "informacion",
          });
          txtApeResp.current.focus();
          sigue = false;
        } else if (txtDireccion.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar la dirección del responsable",
            icono: "informacion",
          });
          txtDireccion.current.focus();
          sigue = false;
        } else if (txtEmail.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el correo del responsable",
            icono: "informacion",
          });
          txtEmail.current.focus();
          sigue = false;
        } else if (txtTlf1.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Telefono del responsable",
            icono: "informacion",
          });
          txtTlf1.current.focus();
          sigue = false;
        } else if (txtTlf2.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el Celular del responsable",
            icono: "informacion",
          });
          txtTlf2.current.focus();
          sigue = false;
        } else if (txtCodAlmacen.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el codigo del almacen",
            icono: "informacion",
          });
          txtCodAlmacen.current.focus();
          sigue = false;
        }
      }
    }

    let client = [];

    for (let i = 0; i < records.length; i++) {
      client.push({
        idcliente: parseInt(records[i].idagente),
        idvendedor: parseInt(txtId.current.value),
      });
    }

    if (sigue) {
      var cliente = [];
      var repre = [];
      cliente.push({
        idagente: txtId.current.value,
        nombre: txtRazon.current.value.toUpperCase().trim(),
        direccion: txtDirClient.current.value.toUpperCase().trim(),
        tipoper: chkNatural.current.checked ? 0 : 1,
        rif: cmbRif.current.value + txtRif.current.value,
        reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
        telefono: txtTlf1Client.current.value,
        celular: txtTlf2Client.current.value,
        email: txtEmailClient.current.value.toUpperCase().trim(),
        vendedor: true,
        statusvendedor: "51",
        estado: txtEstado.current.value.trim(),
        municipio: txtMunicipio.current.value.trim(),
        idalmacen: txtCodAlmacen.current.value,
        ciudad: txtCiudad.current.value.trim(),

        preciomaxventa: txtpreciomaxventa.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        precioofventa: txtprecioofventa.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        preciomayventa: txtpreciomayventa.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        preciominventa: txtpreciominventa.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        debajominventa: txtdebajominventa.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        preciomaxservi: txtpreciomaxservi.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        precioofservi: txtprecioofservi.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        preciomayservi: txtpreciomayservi.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        preciominservi: txtpreciominservi.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        debajominservi: txtdebajominservi.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        preciomaxcob: txtpreciomaxcob.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        precioofcob: txtprecioofcob.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        preciomaycob: txtpreciomaycob.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        debajomincob: txtdebajomincob.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        servimincob: txtservimincob.current.value
          .replace(/\./g, "")
          .replace(",", "."),
        generalcob: txtgeneralcob.current.value
          .replace(/\./g, "")
          .replace(",", "."),
      });
      repre.push({
        cedula: parseInt(txtCedRes.current.value),
        correoe: txtEmail.current.value.toUpperCase().trim(),
        tlf1: txtTlf1.current.value.trim(),
        tlf2: txtTlf2.current.value.trim(),
        apellidos: txtApeResp.current.value.toUpperCase().trim(),
        direccion: txtDireccion.current.value.toUpperCase().trim(),
        fnacimiento: txtFechaNac.current.value.trim(),
        nacionalidad: cmbNacionalidad.current.value.trim(),
        nombres: txtNomResp.current.value.toUpperCase().trim(),
        sexo: cmbSexo.current.value.trim(),
      });

      setBody({
        operacionper: operacionPer,
        agente: cliente,
        repre: repre,
        client: client,
      });

      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/agente/actualizar/${registrado ? 2 : ope
      }`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }

          ContarRegistros();
          seleccionarActivos();
          seleccionarInactivos();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;

        seleccionarRegistro(rif);
      }
    }
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (cmbNacionalidad.current.value !== "") {
          datosRes();
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "debe seleccionar la nacionalidad",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
        }
      } else {
        cmbNacionalidad.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    }
  };

  const onChangeCliente = (e) => {
    if (e.target.name === "estado") {
      setMunicipios([]);
      setCiudades([]);
      if (e.target.value !== "") {
        selectMunicipios(e.target.value);
      }
    } else if (e.target.name === "municipio") {
      setCiudades([]);
      if (e.target.value !== "") {
        selectCiudad(e.target.value);
      }
    } else if (e.target.name === "tipoper") {
      if (parseInt(e.target.value) === 0) {
        chkNatural.current.checked = true;
        setTitleCed("Cédula:");
        setCmbCedula([{ value: "V" }, { value: "E" }]);
      } else {
        chkJuridico.current.checked = true;
        setTitleCed("R.I.F:");
        setCmbCedula([
          { value: "J" },
          { value: "V" },
          { value: "G" },
          { value: "P" },
        ]);
      }
    }
  };

  const onChange = (e) => {
    if (
      e.target.name === "correoe" ||
      e.target.name === "apellidos" ||
      e.target.name === "direccion" ||
      e.target.name === "nombres" ||
      e.target.name === "descripcion"
    ) {
      e.target.value = e.target.value;
    } else if (
      e.target.name === "nacionalidad" &&
      txtCedRes.current.value !== ""
    ) {
      if (e.target.value !== "") {
        datosRes();
      } else {
        txtCedRes.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    }
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);

    if (tipoAgente === "vendedor") {
      if (parseInt(values.tipoper) === 0) {
        chkNatural.current.checked = true;
        setTitleCed("CEDULA:");
        setCmbCedula([{ value: "V" }, { value: "E" }]);
      } else {
        chkJuridico.current.checked = true;
        setTitleCed("R.I.F:");
        setCmbCedula([
          { value: "J" },
          { value: "V" },
          { value: "G" },
          { value: "P" },
        ]);
      }

      txtRazon.current.value = values.nombre;

      seleccionarRegistro(values.rif.trim());
      //datosRes();
      if (!botones.modificar) {
        setBotones({ ...botones, catalogoper: false });
      }
    } else if (tipoAgente === "cliente") {
      var act = [];
      let seguir = true;

      if (records.length > 0) {
        for (let i = 0; i < records.length; i++) {
          act.push(records[i]);

          if (parseInt(values.idagente) === parseInt(records[i].idagente)) {
            seguir = false;
          }
        }

        if (seguir) {
          act.push({
            idagente: values.idagente,
            nombre: values.nombre,
            rif: values.rif,
          });
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "este cliente ya fue seleccionado.",
            icono: "informacion",
          });
        }
      } else {
        act.push({
          idagente: values.idagente,
          nombre: values.nombre,
          rif: values.rif,
        });
      }

      setRecords(act);
    }
  };

  const onCatalogoPersona = (values) => {
    setCatalogoPersona(false);
    setHabilitadoNU(true);
    setOperacionPer(0);
    cmbNacionalidad.current.value = values.nacPer;
    txtCedRes.current.value = values.cedPer;
    cmbSexo.current.value = values.sexoPer;
    txtFechaNac.current.value = moment(values.fnacPer).format("YYYY-MM-DD");
    txtNomResp.current.value = values.nomPer;
    txtApeResp.current.value = values.apePer;
    txtDireccion.current.value = values.direPer;
    txtEmail.current.value = values.correoPer;
    txtTlf1.current.value = values.tlf1Per;
    txtTlf2.current.value = values.tlf2Per;
  };

  const cargarClientes = (id) => {
    let campos = "ag.*, cx.*";
    let nomtab =
      "clientexvendedor as cx inner join agente as ag on ag.idagente=cx.idcliente";
    let condi = `cx.idvendedor=${id}`;
    let orden = "ag.idagente";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&condi=${condi}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const eliminarCliente = (item) => (e) => {
    var act = [];

    if (records.length > 0) {
      for (let i = 0; i < records.length; i++) {
        if (item.idagente !== records[i].idagente) {
          act.push(records[i]);
        }
      }
    }

    setRecords(act);
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (accbtnvendedor && accbtnvendedor.toString().substring(0, 1) === "1") {
        setTituloHeader("Incluir Vendedor.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
          tab1: true,
          tab2: true,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (accbtnvendedor && accbtnvendedor.toString().substring(1, 2) === "1") {
        setTituloHeader("Editar Vendedor.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
          tab1: false,
          tab2: false,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (accbtnvendedor && accbtnvendedor.toString().substring(3, 4) === "1") {
        setTituloHeader("Eliminar Vendedor.");
        setVisibleBtn("hidden");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
          tab1: false,
          tab2: false,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (accbtnvendedor && accbtnvendedor.toString().substring(2, 3) === "1") {
        setTituloHeader("Consultar Vendedor.");
        setVisibleBtn("hidden");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
          tab1: false,
          tab2: false,
        });
        cmbRif.current.removeAttribute("disabled");
        txtRif.current.removeAttribute("disabled");
        chkNatural.current.removeAttribute("disabled");
        chkJuridico.current.removeAttribute("disabled");
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
    }
  };

  const ContarRegistros = () => {
    let valor = "vendedor";
    let boleano = true;

    let endpoint = `${op.conexion}/api/agente/totalregistros?valor=${valor}&boleano=${boleano}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setTotalr(response.data.total);
          setTitulo("Vendedores");
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarActivos = () => {
    let valor = "vendedor";
    let boleano = true;
    let status = "statusvendedor";
    let valstatus = 51;

    let endpoint = `${op.conexion}/api/agente/totalregistrosactivosinactivos?valor=${valor}&boleano=${boleano}&status=${status}&valstatus=${valstatus}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setTotalact(response.data.total);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarInactivos = () => {
    let valor = "vendedor";
    let boleano = true;
    let status = "statusvendedor";
    let valstatus = 52;

    let endpoint = `${op.conexion}/api/agente/totalregistrosactivosinactivos?valor=${valor}&boleano=${boleano}&status=${status}&valstatus=${valstatus}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setTotalinc(response.data.total);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarAlmacen = () => {
    let campos = "idalmacen, trim(descripcion) as descripcion";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let id = txtCodAlmacen.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          txtDescripcion.current.value = "";
          if (response.data !== "") {
            txtDescripcion.current.value = response.data.descripcion.trim();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un almacen con este codigo",
              icono: "informacion",
            });
            txtDescripcion.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarAlmacen = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarAlmacen();
      }
    }
  };

  const onCatalogoAlmacen = (values) => {
    setCatalogoAlmacen(false);
    txtCodAlmacen.current.value = values.idalmacen;
    txtDescripcion.current.value = values.descripcion;
  };

  useEffect(() => {
    seleccionarRegistros();
    ContarRegistros();
    seleccionarActivos();
    seleccionarInactivos();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12" style={{ margin: 0 }}>
          <div className="col-md-9 py-1 mx-auto mt-2 card shadow rounded">
            <div className="col-md-12 row mx-auto border-azul rounded pt-2">
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-1 azulGradiant shadow text-light justify-content-between">
                <div className="col-md-4">
                  <h3>{tituloHeader}</h3>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salirr</span>
                  </a>
                </div>
              </div>

              <ul className="nav mb-1" id="ex-with-icons" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    style={{ pointerEvents: botones.tab1 ? "none" : "auto" }}
                    className="nav-link text-light bg-blue-100 rounded"
                    id="ex-with-icons-tab-1"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-1"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-1"
                    aria-selected="true"
                  >
                    <i className="fas fa-briefcase fa-fw me-2" />
                    Datos del Vendedor
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    style={{ pointerEvents: botones.tab2 ? "none" : "auto" }}
                    className="nav-link text-light bg-blue-200 rounded "
                    id="ex-with-icons-tab-2"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-2"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-2"
                    aria-selected="false"
                  >
                    <i className="fas fa-clipboard fa-fw me-2" />
                    Clientes
                  </a>
                </li>
              </ul>

              <div
                className="tab-content"
                id="ex-with-icons-content"
                style={{ fontFamily: "Times New Roman, Times, serif" }}
              >
                <div
                  className="tab-pane fade show active "
                  id="ex-with-icons-tabs-1"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-1"
                >
                  <div className="col-md-12 mx-auto row">
                    <div
                      className="col-md-12 mt-2"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Datos del Vendedor
                        </legend>
                        <input
                          ref={txtId}
                          autoComplete="off"
                          type="hidden"
                          className="form-control"
                          name="idagente"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                        <div className="mb-1 col-pd-260 px-2">
                          <div className="input-group input-group-sm">
                            <label
                              className="input-group-text"
                              id="inputGroup-sizing-sm"
                            >
                              {titleCed}{" "}
                            </label>
                            <select
                              ref={cmbRif}
                              name="cmbrif"
                              disabled
                              className="form-select form-select-sm text-center col-3"
                              aria-label=".form-select-sm example"
                              onChange={onChange}
                            >
                              <option value="">--</option>
                              {cmbCedula &&
                                cmbCedula.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {" "}
                                    {item.value}{" "}
                                  </option>
                                ))}
                            </select>
                            <input
                              ref={txtRif}
                              autoComplete="off"
                              disabled
                              maxLength={9}
                              type="text"
                              className="form-control fs-6"
                              name="cedula"
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                              onKeyUp={validarCliente}
                              onBlur={validarCliente}
                              onChange={onChange}
                            />
                            <button
                              disabled={botones.catalogo}
                              type="button"
                              onClick={() => {
                                setTipoAgente("vendedor");
                                setCatalogoCliente(true);
                              }}
                              className="btn btn-success"
                            >
                              <i className="fas fa-search"></i>
                            </button>
                          </div>
                        </div>

                        <div className="col-pd-410 mb-1">
                          <div className="row m-0">
                            <label className="col-6">TIPO PERSONA: </label>
                            <div className="col">
                              <div className="form-check">
                                <input
                                  className="form-check-input my-auto"
                                  disabled
                                  type="radio"
                                  name="tipoper"
                                  value={0}
                                  ref={chkNatural}
                                  defaultChecked
                                  id="tipoper"
                                  onChange={onChangeCliente}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="tipoper"
                                >
                                  {" "}
                                  Natural{" "}
                                </label>
                              </div>
                            </div>
                            <div className="col">
                              <div className="form-check">
                                <input
                                  className="form-check-input my-auto"
                                  disabled
                                  type="radio"
                                  name="tipoper"
                                  value={1}
                                  ref={chkJuridico}
                                  id="tipoper"
                                  onChange={onChangeCliente}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="tipoper"
                                >
                                  {" "}
                                  Juridica{" "}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-12">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            {titleCed === "CEDULA:"
                              ? "NOMBRES Y APELLIDOS"
                              : "NOMBRE/RAZON SOCIAL"}
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtRazon}
                            disabled={habilitado}
                            name="nombres"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-12">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            DIRECCION:
                          </label>
                          <textarea
                            type="area"
                            autoComplete="off"
                            ref={txtDirClient}
                            disabled={habilitado}
                            name="direccion"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            style={{ height: 40 }}
                          />
                        </div>

                        <div className="input-group input-group-sm mb-1 col-pd-240 px-2">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            ESTADO:
                          </label>
                          <select
                            ref={txtEstado}
                            disabled={habilitado}
                            onChange={onChangeCliente}
                            name="estado"
                            idciudad="estado"
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                          >
                            <option value="">seleccione</option>
                            {estados &&
                              estados.map((item, index) => (
                                <option key={index} value={item.idestado}>
                                  {item.nombre}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            MUNICIPIO:
                          </label>
                          <select
                            ref={txtMunicipio}
                            disabled={habilitado}
                            onChange={onChangeCliente}
                            name="municipio"
                            id="municipio"
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                          >
                            <option value="">seleccione</option>
                            {municipios &&
                              municipios.map((item, index) => (
                                <option key={index} value={item.idmunicipio}>
                                  {item.nombre}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-3">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            CIUDAD:
                          </label>
                          <select
                            ref={txtCiudad}
                            disabled={habilitado}
                            name="ciudad"
                            id="ciudad"
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                          >
                            <option value="">seleccione</option>
                            {ciudades &&
                              ciudades.map((item, index) => (
                                <option key={index} value={item.idciudad}>
                                  {item.nombre}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="input-group input-group-sm mb-1 col-pd-200 px-2 ml-auto">
                          <label
                            className="input-group-text px-1"
                            id="inputGroup-sizing-sm"
                          >
                            CELULAR:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            maxLength={11}
                            ref={txtTlf2Client}
                            disabled={habilitado}
                            className="form-control fs-6 px-1"
                            name="tlf2"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={handleInputNumChange}
                          />
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            EMAIL:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtEmailClient}
                            disabled={habilitado}
                            className="form-control text-uppercase fs-6"
                            name="correoe"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-pd-210 px-1">
                          <label
                            className="input-group-text px-1"
                            id="inputGroup-sizing-sm"
                          >
                            TELEFONO:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            maxLength={11}
                            ref={txtTlf1Client}
                            disabled={habilitado}
                            className="form-control fs-6 px-1"
                            name="tlf1"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={handleInputNumChange}
                          />
                        </div>
                      </fieldset>
                    </div>
                    <div
                      className="col-md-12"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Responsable
                        </legend>

                        <div className="col-pd-270 mb-1 px-2">
                          <div className="input-group input-group-sm">
                            <label
                              className="input-group-text"
                              id="inputGroup-sizing-sm"
                            >
                              CEDULA:
                            </label>
                            <select
                              ref={cmbNacionalidad}
                              name="nacionalidad"
                              className="form-select form-select-sm col-md-3"
                              disabled={habilitado}
                              aria-label=".form-select-sm example"
                              onChange={onChange}
                            >
                              <option value="">--</option>
                              <option value="V">V</option>
                              <option value="E">E</option>
                            </select>
                            <input
                              ref={txtCedRes}
                              maxLength={8}
                              autoComplete="off"
                              type="text"
                              disabled={habilitado}
                              className="form-control fs-6"
                              name="cedula"
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                              onKeyUp={validarPersona}
                              onBlur={validarPersona}
                              onChange={onChange}
                            />
                            <button
                              disabled={botones.catalogoper}
                              type="button"
                              onClick={() => setCatalogoPersona(true)}
                              className="btn btn-success"
                            >
                              <i className="fas fa-search"></i>
                            </button>
                          </div>
                        </div>

                        <div className="col-pd-140 ml-auto mb-1">
                          <div className="input-group input-group-sm">
                            <label
                              className="input-group-text"
                              id="inputGroup-sizing-sm"
                            >
                              SEXO:
                            </label>
                            <select
                              ref={cmbSexo}
                              className="form-select form-select-sm"
                              name="sexo"
                              disabled={habilitadoNU}
                              onChange={onChange}
                              aria-label=".form-select-sm example"
                            >
                              <option value="">--</option>
                              <option value="M">M</option>
                              <option value="F">F</option>
                            </select>
                          </div>
                        </div>

                        <div className="mb-1 col-pd-340 ml-auto px-2">
                          <div className="input-group input-group-sm">
                            <label
                              className="input-group-text"
                              id="inputGroup-sizing-sm"
                            >
                              FECHA DE NACIMIENTO
                            </label>
                            <input
                              type="date"
                              ref={txtFechaNac}
                              max={fechaTope}
                              className="form-control fs-6 text-uppercase"
                              name="fnacimiento"
                              aria-label="Sizing example input"
                              onChange={onChange}
                              disabled={habilitadoNU}
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </div>
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-6">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            NOMBRES:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtNomResp}
                            name="nombres"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-md-6">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            APELLIDOS:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtApeResp}
                            name="apellidos"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-md-12">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            DIRECCION:
                          </label>
                          <textarea
                            type="area"
                            autoComplete="off"
                            ref={txtDireccion}
                            name="direccion"
                            className="form-control text-uppercase fs-6"
                            onChange={onChange}
                            aria-label="Sizing example input"
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                            style={{ height: 40 }}
                          />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-md-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            EMAIL:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtEmail}
                            className="form-control text-uppercase fs-6"
                            name="correoe"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-pd-210 px-1">
                          <label
                            className="input-group-text px-1"
                            id="inputGroup-sizing-sm"
                          >
                            TELEFONO:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            maxLength={11}
                            ref={txtTlf1}
                            className="form-control fs-6 px-1"
                            name="tlf1"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={handleInputNumChange}
                          />
                        </div>
                        <div className="input-group input-group-sm mb-1 col-pd-210">
                          <label
                            className="input-group-text px-1"
                            id="inputGroup-sizing-sm"
                          >
                            CELULAR:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            maxLength={11}
                            ref={txtTlf2}
                            className="form-control fs-6 px-1"
                            name="tlf2"
                            aria-label="Sizing example input"
                            onChange={onChange}
                            disabled={habilitadoNU}
                            aria-describedby="inputGroup-sizing-sm"
                            onKeyUp={handleInputNumChange}
                          />
                        </div>
                      </fieldset>
                    </div>
                    <div
                      className="col-md-12"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Almacen
                        </legend>
                        <div className="input-group input-group-sm mb-1 col-md-3 col-lg-2 col-sm-4">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            CODIGO:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            ref={txtCodAlmacen}
                            disabled={habilitado}
                            onKeyUp={validarAlmacen}
                            onBlur={validarAlmacen}
                            name="idalmacen"
                            className="form-control fs-6"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                          <button
                            disabled={botones.catalogoper}
                            onClick={() => setCatalogoAlmacen(true)}
                            type="button"
                            className="btn btn-success"
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>

                        <div className="input-group input-group-sm mb-1 col-md-9 col-lg-10 col-sm-8">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            DESCRIPCION:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            disabled
                            ref={txtDescripcion}
                            onChange={onChange}
                            name="descripcion"
                            className="form-control text-uppercase fs-6"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                      </fieldset>
                    </div>
                    <div
                      className="col-pd-350 mb-1"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Comisiones de Venta{" "}
                        </legend>
                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Máximo:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciomaxventa}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Oferta:
                          </label>
                          <input
                            type="text"
                            ref={txtprecioofventa}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Mayor:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciomayventa}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Minimo:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciominventa}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Por debajo del Minimo:
                          </label>
                          <input
                            type="text"
                            ref={txtdebajominventa}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                      </fieldset>
                    </div>
                    <div
                      className="col-pd-350 mb-1 mx-auto"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Comisiones de Servicios
                        </legend>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Máximo:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciomaxservi}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Oferta:
                          </label>
                          <input
                            type="text"
                            ref={txtprecioofservi}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Mayor:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciomayservi}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Minimo:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciominservi}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Por Debajo del Minimo:
                          </label>
                          <input
                            type="text"
                            ref={txtdebajominservi}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                      </fieldset>
                    </div>
                    <div
                      className="col-pd-350 mb-1"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <fieldset className=" row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between">
                        <legend
                          className="float-none w-auto fw-bold"
                          style={{ fontSize: "15px" }}
                        >
                          Comisiones de Cobranza{" "}
                        </legend>

                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Máximo:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciomaxcob}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Oferta:
                          </label>
                          <input
                            type="text"
                            ref={txtprecioofcob}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Precio Mayor:
                          </label>
                          <input
                            type="text"
                            ref={txtpreciomaycob}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Servicio Minimo:
                          </label>
                          <input
                            type="text"
                            ref={txtservimincob}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % Por debajo del Mínimo:
                          </label>
                          <input
                            type="text"
                            ref={txtdebajomincob}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                        <div className="input-group input-group-sm mb-2 col-md-12 mx-auto">
                          <label
                            style={{ fontSize: "12px" }}
                            className="input-group-text col-md-8 border-0 bg-transparent"
                            id="inputGroup-sizing-sm"
                          >
                            % General de Cobranza:
                          </label>
                          <input
                            type="text"
                            ref={txtgeneralcob}
                            onFocus={seleccionarCampo}
                            disabled={habilitado}
                            onKeyUp={handleInputMontoChange}
                            onBlur={handleInputMontoChange}
                            className="form-control rounded text-right fs-6"
                            placeholder="0,00"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                          />
                        </div>
                      </fieldset>
                    </div>
                    <div className="col-md-12 py-1">
                      {visibleBtn !== "visible" ? (
                        <div className="col-pd-botonesd row m-0 ml-auto">
                          <button
                            ref={btnAcepta}
                            disabled={botones.aceptar}
                            onClick={onBotones(5)}
                            className="btn btn-sm col ml-1 rounded-pill btn-success"
                          >
                            <i className="fas fa-check-circle"> Aceptar</i>
                          </button>
                          <button
                            ref={btnCancela}
                            disabled={botones.cancelar}
                            onClick={onBotones(6)}
                            className="btn btn-danger col ml-1 btn-sm rounded-pill"
                          >
                            <i className="fas fa-window-close"> Cancelar</i>
                          </button>
                        </div>
                      ) : (
                        <div className="col-pd-botones">
                          <div className="col-md-12 row m-0">
                            <button
                              disabled={botones.incluir}
                              onClick={onBotones(1)}
                              className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                              title="Incluir Almacen"
                            >
                              <i className="fas fa-plus"> Incluir </i>{" "}
                            </button>
                            <button
                              disabled={botones.consultar}
                              onClick={onBotones(4)}
                              className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                              title="Consultar Almacen"
                            >
                              <i className="fas fa-eye"> Consultar</i>{" "}
                            </button>
                            <button
                              disabled={botones.modificar}
                              onClick={onBotones(2)}
                              className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                              title="Modificar Almacen"
                            >
                              <i className="fa fa-edit"> Modificar</i>{" "}
                            </button>
                            <button
                              disabled={botones.eliminar}
                              onClick={onBotones(3)}
                              className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                              title="Eliminar Almacen"
                            >
                              <i className="fa fa-trash"> Eliminar</i>{" "}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="ex-with-icons-tabs-2"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-2"
                >
                  <div className="col-md-12 py-1">
                    <div className="col-12 p-2">
                      <div className="row col-12 d-flex justify-content-between">
                        <input
                          type="text"
                          className=" col-3 form-control form-control-sm rounded-pill"
                          ref={txtBuscador}
                          onChange={handleSearch}
                          placeholder="Buscar"
                        />
                        <div className="col-3 d-flex justify-content-end">
                          <button
                            onClick={() => {
                              setTipoAgente("cliente");
                              setCatalogoCliente(true);
                            }}
                            className="btn btn-sm btn-primary rounded-circle"
                          >
                            <i className="fas fa-plus"></i>{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 m-0">
                      <TblContainer>
                        <TblHead />
                        <TableBody>
                          {records &&
                            recordsAfterPagingAndSorting().map(
                              (item, index) => (
                                <TableRow key={index} style={{ padding: "0" }}>
                                  <TableCell
                                    className="align-baseline"
                                    style={{
                                      textAlign: "center",
                                      alignItems: "center",
                                      width: "50px",
                                    }}
                                  >
                                    {item.idagente}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline"
                                    style={{
                                      textAlign: "center",
                                      alignItems: "center",
                                      width: "350px",
                                    }}
                                  >
                                    {item.nombre}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline"
                                    style={{
                                      textAlign: "center",
                                      alignItems: "center",
                                      width: "50px",
                                    }}
                                  >
                                    {item.rif}
                                  </TableCell>
                                  <TableCell
                                    className="align-baseline"
                                    style={{
                                      textAlign: "center",
                                      alignItems: "center",
                                      width: "50px",
                                    }}
                                  >
                                    <button
                                      onClick={eliminarCliente(item)}
                                      className="btn btn-sm mx-1 btn-danger rounded-circle"
                                    >
                                      <i className="fa fa-trash"></i>{" "}
                                    </button>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </TblContainer>
                      <TblPagination />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 py-4 ocultodos">
            <CartasProveedores
              totalr={totalr}
              totalact={totalact}
              totalinc={totalinc}
              titulo={titulo}
            />
          </div>
        </div>
      </div>

      <CatalogoAlmacen
        show={catalogoAlmacen}
        onHideCancelar={() => setCatalogoAlmacen(false)}
        onHideAceptaCatalogo={onCatalogoAlmacen}
      />

      <CatalogoCliente
        show={catalogoCliente}
        nomid={tipoAgente}
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />

      <CatalogoPersona
        show={catalogoPersona}
        onHideCancelaCatPer={() => setCatalogoPersona(false)}
        onHideAceptaCatPer={onCatalogoPersona}
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaVendedores;



// WEBPACK FOOTER //
// ./src/components/ventas/tablaVendedores.js